var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.componentType,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          class: [
            _vm.$style["mds-button"],
            _vm.classObject,
            _vm.variationClass,
            _vm.sizeClass,
          ],
          attrs: {
            "aria-label": _vm.iconAriaLabel,
            href: _vm.href,
            "data-mds-version": _vm.version,
          },
        },
        "component",
        _vm.routingProps,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.icon
        ? _c("mds-icon", {
            class: [
              _vm.$style["mds-button__icon"],
              _vm.$style["mds-button__icon--left"],
            ],
            attrs: { name: _vm.icon, size: _vm.iconSize },
          })
        : _vm._e(),
      _vm.variation !== "icon-only"
        ? _c(
            "span",
            [
              _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.text))]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.iconRight
        ? _c("mds-icon", {
            class: [
              _vm.$style["mds-button__icon"],
              _vm.$style["mds-button__icon--right"],
            ],
            attrs: { name: _vm.iconRight, size: _vm.iconSize },
          })
        : _vm._e(),
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": _vm.$style["mds-button__loader-enter-active"],
            "leave-active-class": _vm.$style["mds-button__loader-leave-active"],
            "enter-class": _vm.$style["mds-button__loader-enter"],
            "leave-to-class": _vm.$style["mds-button__loader-leave-to"],
          },
        },
        [
          _vm.loading && _vm.variation === "primary"
            ? _c("mds-loader", {
                class: [_vm.$style["mds-button__loader"]],
                attrs: {
                  "aria-valuetext": _vm.loaderAriaValuetext,
                  "on-dark": "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }